import React, { useState } from 'react';
import CountUp from 'react-countup';
import styles from '../css/TemperatureSalesBox.module.css';
import vsblLogo from '../bin/images/vsbl_Logo_Full_Color_RGB.svg';
import monitoringImage from '../bin/images/temperature_monitoring_home_page.png';
import prepnprintLogo from '../bin/images/prepnprint.png';
import PathConstants from '../routes/pathConstants';

function TemperatureSalesBox() {
    const [additionalSensors, setAdditionalSensors] = useState(0);
    const [prevPrice, setPrevPrice] = useState(199);
    const basePrice = 199;
    const sensorPrice = 16; // Price per 2 sensors increment
    const totalPrice = basePrice + (additionalSensors * sensorPrice);

    const handleIncrement = () => {
        setAdditionalSensors(prev => prev + 1);
    };

    const handleDecrement = () => {
        if (additionalSensors > 0) {
            setAdditionalSensors(prev => prev - 1);
        }
    };

    const handleSignUpClick = () => {
        window.open(PathConstants.SignUp, '_blank');
    };

    return (
        <div className={styles.salesBoxContainer}>
            <div className={styles.salesBoxInner}>
                <h2 className={styles.salesBoxTitle}>Sign Up Now</h2>

                <div className={styles.salesCard}>
                    <div className={styles.newOfferBadge}>NEW OFFER!</div>

                    <div className={styles.cardHeader}>
                        <img src={vsblLogo} alt="VSBL Logo" className={styles.vsblLogo} />
                        <span className={styles.plusSign}>+</span>
                        <span className={styles.temperatureTitle}>Temperature Sensors</span>
                    </div>

                    <p className={styles.description}>
                        The entire VSBL ecosystem, plus Remote Temperature Monitoring that features
                        8 temperature sensors with a 15-year battery life plus a cellular gateway. Additional
                        sensors available for additional monthly charge.
                    </p>

                    <div className={styles.pricingSection}>
                        <div className={styles.pricingLeft}>
                            <div className={styles.priceDisplay}>
                                <span className={styles.priceAmount}>$
                                    <CountUp
                                        start={prevPrice}
                                        end={totalPrice}
                                        duration={1}
                                        preserveValue={true}
                                    />
                                </span>
                                <div className={`${styles.priceDetailsWrapper} ${totalPrice >= 1000 ? styles.priceDetailsWrapperWide : ''}`}>
                                    <span className={styles.priceDetails}>/ month + tax</span>
                                </div>
                            </div>

                            <div className={styles.additionalSensorsSection}>
                                <div className={styles.sensorControls}>
                                    <label className={styles.sensorLabel}>
                                        Additional Sensors
                                        <span className={styles.sensorSubtext}>
                                            Add more sensors in increments of 2<br />
                                            (+$16 per 2 sensors)
                                        </span>
                                    </label>
                                    <div className={styles.counterControls}>
                                        <button
                                            className={styles.counterButton}
                                            onClick={handleDecrement}
                                            disabled={additionalSensors === 0}
                                        >
                                            −
                                        </button>
                                        <span className={styles.counterValue}>
                                            {additionalSensors * 2}
                                        </span>
                                        <button
                                            className={styles.counterButton}
                                            onClick={handleIncrement}
                                        >
                                            +
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={styles.productImages}>
                            <img
                                src={monitoringImage}
                                alt="Temperature Sensor and Cloud Connector"
                                className={styles.productImage}
                            />
                        </div>
                    </div>

                    <button className={styles.signUpButton} onClick={handleSignUpClick}>
                        Sign Up Now
                    </button>

                    <div className={styles.featuresColumns}>
                        <div className={styles.featureColumn}>
                            <h3 className={styles.columnTitle}>The VSBL Ecosystem</h3>
                            <ul className={styles.featureList}>
                                <li><span className={styles.checkmark}>✓</span> Waste Tracking</li>
                                <li><span className={styles.checkmark}>✓</span> Reporting</li>
                                <li><span className={styles.checkmark}>✓</span> Checklists</li>
                                <li><span className={styles.checkmark}>✓</span> Tasks</li>
                                <li><span className={styles.checkmark}>✓</span> Shifts</li>
                                <li><span className={styles.checkmark}>✓</span> Break Management</li>
                                <li><span className={styles.checkmark}>✓</span> Accountability</li>
                                <li><span className={styles.checkmark}>✓</span> Rewards</li>
                                <li><span className={styles.checkmark}>✓</span> Vendors</li>
                            </ul>
                        </div>

                        <div className={styles.featureColumn}>
                            <h3 className={styles.columnTitle}>+ Temperature Sensors</h3>
                            <ul className={styles.featureList}>
                                <li><span className={styles.checkmark}>✓</span> Access to Remote Temperature Monitoring</li>
                                <li><span className={styles.checkmark}>✓</span> 8 Temperature Sensors + 1 Gateway included</li>
                                <li><span className={styles.checkmark}>✓</span> 15-year battery life</li>
                                <li><span className={styles.checkmark}>✓</span> Sensors stay continuously connected</li>
                                <li><span className={styles.checkmark}>✓</span> Real time temperature alerts</li>
                            </ul>

                            <div className={styles.plusSection}>
                                <span className={styles.plusLabel}>PLUS!</span>
                                <ul className={styles.bonusList}>
                                    <li>
                                        <span className={styles.checkmark}>✓</span>
                                        1 free roll of
                                        <img src={prepnprintLogo} alt="PrepNPrint" className={styles.prepnprintLogo} />
                                        2"x2" labels
                                    </li>
                                    {/* <li><span className={styles.checkmark}>✓</span> Refer 3 friends for up to 3 months free</li> */}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TemperatureSalesBox;